export default __webpack_public_path__ + "static/media/2020 (3).19ab4778.JPG";